import { createDefaultClient } from '../../utils/createDefaultClient';
import { DefaultClient } from '../../types';
import { Host } from '@wix/sdk';

export const createClientsForHosts = (hosts: Host[]): DefaultClient[] => {
  return hosts.map(createDefaultClient);
};
